import request from './request'

// 通用请求方法
export function http_post(url, data) {
  return request({
    url: url,
    method: 'post',
    data
  })
}

export function http_get(url) {
  return request({
    url: url,
    method: 'get'
  })
}

// 登陆 或 注册
export function login(data) {
  return request({
    url: '/api/admin/account/login',
    method: 'post',
    data
  })
}

// 检查token
export function check_token() {
  return request({
    url: '/api/admin/account/check_token',
    method: 'get'
  })
}

// 获取管理员信息
export function admin_info() {
  return request({
    url: '/api/admin/account/admin_info',
    method: 'get'
  })
}

//
export function getTopMenu() {
  return request({
    url: '/api/dev/apps/get_top_menu',
    method: 'get'
  })
}

export function getAppInfo(data) {
  return request({
    url: '/api/dev/apps/get_info',
    method: 'post',
    data
  })
}

export function getPageList(data) {
  return request({
    url: '/api/dev/page/get_list',
    method: 'post',
    data
  })
}

export function getPageInfo(data) {
  return request({
    url: '/api/dev/page/get_item',
    method: 'post',
    data
  })
}

export function addPage(data) {
  return request({
    url: '/api/dev/page/add_item',
    method: 'post',
    data
  })
}

export function delPage(data) {
  return request({
    url: '/api/dev/page/del_item',
    method: 'post',
    data
  })
}

export function changeUserStatus(data) {
  return request({
    url: '/api/admin/user/account/change_status',
    method: 'post',
    data
  })
}

export function adminChangeWorkStatus(data) {
  return request({
    url: '/api/admin/work_account/update_status',
    method: 'post',
    data
  })
}

export function changeEmployerBalance(data) {
  return request({
    url: '/api/admin/employer/wallet/change_money',
    method: 'post',
    data
  })
}

// 获取所有项目
export function get_all_project(data) {
  return request({
    url: '/api/admin/project/get_all',
    method: 'get',
    data
  })
}

export function get_all_employer(data) {
  return request({
    url: '/api/admin/employer/get_all',
    method: 'get',
    data
  })
}

export function changeUserBalance(data) {
  return request({
    url: '/api/admin/user/account/change_money',
    method: 'post',
    data
  })
}

export function clearUserBalance(data) {
  return request({
    url: '/api/admin/user/account/clear_balance',
    method: 'post',
    data
  })
}
